import EmbudoLogo from "../../../assets/Embudo-Loading.webm";

const EmbudoLoading = () => {
  return (
    <div
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <video
        autoPlay
        loop
        muted
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -1,
        }}
      >
        <source src={EmbudoLogo} type="video/webm"></source>
      </video>
    </div>
  );
};

export default EmbudoLoading;
